/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 17:15:03
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-06 10:42:37
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Select/index.tsx
 */
import { Select } from 'antd';
import React from 'react';
import SearchSelect from './SearchSelect/SearchSelect';
import css from './Select.less';
import { generateOptions } from './tools';

export { generateOptions, SearchSelect };
export { _Select as Select };
// interface IProps {
//   optionsList?: OptionsList[];
//   rightBtn?: RightBtn;
//   size?;
//   value?;
//   onChange?;
//   status?: EnumFormItemStatus;
//   help?: string | ReactNode;
//   optionsGroupList?: OptionsGroupList[];
//   error?: boolean;
// }

const _Select = (props) => {
  const {
    size,
    value,
    onChange,
    // status,

    selectClassName,
    dropdownClassName,
    children,
    containerClassName,
    disabled,
    placeholder,
    ...rest
  } = props;

  return (
    <div className={`${css.selectContain} ${containerClassName || ''}`}>
      <Select
        // suffixIcon={<div>123</div>}
        placeholder={placeholder}
        size={size}
        value={value}
        onChange={onChange}
        className={`${css.select} ${selectClassName || ''}`}
        dropdownClassName={`${css.dropdown} ${dropdownClassName || ''}`}
        disabled={disabled}
        {...rest}>
        {children}
      </Select>
    </div>
  );
};
// const _Option = (props: any) => {
//   const { children, ...rest } = props;
//   return <Select.Option {...rest}>{children}</Select.Option>;
// };

// const _OptionGroup = (props: any) => {
//   const { children, ...rest } = props;
//   return <Select.OptGroup {...rest}>{children}</Select.OptGroup>;
// };

_Select.Option = Select.Option;
_Select.OptionGroup = Select.OptGroup;
export default _Select;
